import React from "react";

import { useTranslation } from "react-i18next";

import { Checkbox } from "@/src/components/ui/checkbox";

import {
  SELECT_CHECKBOX_CLASS,
  SELECT_CHECKBOX_WRAPPER_CLASS,
} from "./dataTableStyles";

import type { RowData } from "@tanstack/react-table";
import type { JSX } from "react";

import type { DataTableInstance } from "./dataTable.types";

interface DataTableSelectHeaderProps<TData extends RowData> {
  table: DataTableInstance<TData>;
}

function DataTableSelectHeader<TData extends RowData>({
  table,
}: DataTableSelectHeaderProps<TData>): JSX.Element {
  const { t } = useTranslation("table");
  const isAllSelected = table.getIsAllPageRowsSelected();
  const isSomeSelected = table.getIsSomePageRowsSelected();

  return (
    <div className={SELECT_CHECKBOX_WRAPPER_CLASS}>
      <Checkbox
        aria-label={t("dataTable.selectAll")}
        checked={isAllSelected || (isSomeSelected && "indeterminate")}
        className={SELECT_CHECKBOX_CLASS}
        onCheckedChange={(value) =>
          table.toggleAllPageRowsSelected(value === true)
        }
      />
    </div>
  );
}

export default DataTableSelectHeader;
